const features = [
  {
    id: 1,
    title: '海量资源',
    desc: '覆盖西瓜视频免费、免费视频网站91等热门频道，超10万部高清电影电视剧资源，题材丰富应有尽有',
    icon: 'ri-database-2-line',
    colorClass: 'text-primary-500',
    bgClass: 'bg-primary-100',
  },
  {
    id: 2,
    title: '高清流畅',
    desc: '全高清画质在线播放，智能CDN加速技术确保零缓冲体验，无论何时何地都能流畅观看',
    icon: 'ri-4k-line',
    colorClass: 'text-accent-600',
    bgClass: 'bg-accent-100',
  },
  {
    id: 3,
    title: '完全免费',
    desc: '无需注册、无需登录、无需付费，打开网站即可免费观看全部影片，没有任何隐藏收费',
    icon: 'ri-money-cny-circle-line',
    colorClass: 'text-secondary-600',
    bgClass: 'bg-secondary-100',
  },
  {
    id: 4,
    title: '每日更新',
    desc: '专业团队每日持续更新最新电影和热播剧集，同步各大平台热门内容，让你不错过任何精彩',
    icon: 'ri-calendar-check-line',
    colorClass: 'text-primary-500',
    bgClass: 'bg-primary-100',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            为什么数百万用户选择苹果视频？四大核心优势让你畅享观影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl p-6 md:p-7 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className={`w-12 h-12 rounded-xl ${item.bgClass} flex items-center justify-center mb-5 transition-transform duration-300 group-hover:scale-110`}>
                <i className={`${item.icon} ${item.colorClass} text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}